<template>
  <div>
    <spinner v-if="loading"></spinner>
    <router-link :to="{name: 'Field Template Create'}">
      <button v-if="!loading"
              class="btn green margin-bottom-10">
        Add New
      </button>
    </router-link>
    <vue-good-table v-if="!loading"
                    :columns="columns"
                    :rows="templates"
                    :pagination-options="{'enabled': true}">

      <div slot="emptystate">
        No forms available.
      </div>
      <template slot="table-row" slot-scope="props">
        <template v-if="props.column.field ==='actions'">
          <div class="last-dropdown">
            <actions-menu>
              <actions-menu-item
                title="Edit"
                icon="fa-edit"
                :to="{ name: 'Field Template Edit', params: { id: props.row.id } }"
              />
              <actions-menu-item
                title="Remove"
                icon="fa-trash"
                @click.prevent="showDeletionModal(props.row)"
              />
            </actions-menu>
          </div>

        </template>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
      </template>
    </vue-good-table>
    <confirmation-modal id="delete-confirmation"
                        title="DELETE TEMPLATE"
                        question="Are you sure you would like to delete this template?"
                        @confirmed="removeTemplate(templateToDelete)"/>
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';

import ActionsMenu from "../../reusables/ActionsMenu";
import ActionsMenuItem from "../../reusables/ActionsMenuItem";
import ConfirmationModal from "@/components/modals/ConfirmationModal";
import Spinner from '@/components/Spinner';

export default {
  components: {
    ActionsMenu,
    ActionsMenuItem,
    ConfirmationModal,
    Spinner,
  },
  data () {
    return {
      templateToDelete: null,
      columns: [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      loading: 'fieldTemplates/getLoading',
      templates: 'fieldTemplates/getFieldTemplates',
    })
  },
  methods: {
    ...mapActions({
      fetchTemplates: 'fieldTemplates/fetchFieldTemplates',
      removeTemplate: 'fieldTemplates/removeFieldTemplate',
    }),
    showDeletionModal(template) {
      this.templateToDelete = template;
      $('#delete-confirmation').modal('show');
    },
  },
  mounted () {
    this.fetchTemplates();
  }
}
</script>



// WEBPACK FOOTER //
// FieldTemplatesIndex.vue?04d654cd